import React from "react";
import LandingPageLayout from "../../shared/Layouts/LandingPageLayout";
import { CUSTOMARIUS } from "../../assets";

function CourtDocuments() {
  return (
    <LandingPageLayout
      title={<>Court Documents</>}
      currentLink="Court Documents"
    >
      <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 py-8 sm:py-10 px-4 sm:px-8 lg:px-20 gap-4 sm:gap-5">
        {[1].map((_, index) => (
          <div
            key={index}
            className="w-full h-fit border-b-[3px] rounded-b-xl border-globalGreen bg-white shadow-lg gap-y-2 sm:gap-y-3 flex flex-col items-center rounded-md p-3 sm:p-4"
          >
            <img
              src={CUSTOMARIUS}
              className="w-full max-w-[190px] h-auto object-contain"
              alt="Court Document"
            />
            <span className="text-globalGreen text-center text-sm sm:text-[16px] font-medium">
              Customarius
            </span>
            <span className="text-xs sm:text-sm text-gray-regular">
              Issue 8
            </span>
          </div>
        ))}
      </div>
    </LandingPageLayout>
  );
}

export default CourtDocuments;
